webpackJsonp([22],{

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_MorphSVGPlugin__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_MorphSVGPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libs_MorphSVGPlugin__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var smoke = this.el.querySelectorAll("#leprechaun-smoke ellipse");
      var clover = this.el.querySelector("#leprechaun-clover");

      this.animation = new TimelineMax().staggerTo(smoke, 8, {
        y: -150,
        scale: 3,
        repeat: -1,
        opacity: 0,
        ease: Power1.easeOut,
        transformOrigin: "center"
      }, 2, 0).to(clover, 5, {
        rotation: 600,
        transformOrigin: "center",
        repeat: -1,
        yoyo: true,
        ease: Power2.easeInOut
      }, 0);

      this.animation.paused(!this.props.isActive);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.animation.paused(!nextProps.isActive);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { ref: function ref(el) {
            return _this2.el = el;
          }, viewBox: "2 120.9 600 600" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M602 420.9c0 165.7-134.3 300-300 300S2 586.6 2 420.9s134.3-300 300-300 300 134.3 300 300z",
          fill: "#4DB6AC"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M295.3 614.6c-.3 3.4-.7 6.7-1 9.8-.4 3.6-1 7-1.7 9.8-1.4 5.5-3.4 9.1-6.9 9.1-4.9 0-8.2-3-10.3-9.1-.9-2.7-1.6-5.9-2.1-9.8-.4-2.9-.7-6.2-.9-9.8h22.9zM297 600.3c-.3 1.8-.5 3.5-.8 5.4v-.8h-24.1v-6c0-15 8.2-16.6 13.6-16.6 5.4-.1 13.7 3.2 11.3 18z",
          fill: "#B71C1C"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M296.3 604.8v.8c-.4 3-.7 6-1 9h-22.8c-.2-3-.3-6.3-.3-9.8h24.1z",
          fill: "#FF0"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M294.2 624.5c-.4 3.6-1 7-1.7 9.8h-17.1c-.9-2.7-1.6-5.9-2.1-9.8h20.9z",
          fill: "#FFD400"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M364.2 410.1c0 33.8 42.5 96.9-52.1 101.1-84.5 3.8-60.4-62.9-60.4-96.6s24.6-44.5 58.1-44.5c33.6 0 54.4 6.2 54.4 40z",
          fill: "#F0E6EB"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M320.4 524.2c2 15.7-14.5 69.7-26.6 67.4-6-1.1-9.6 0-13.6 0-15 0-36.6-46.3-36.6-65.7 0-19.4 24.6-20.4 39.6-20.4s34.8-.5 37.2 18.7z",
          fill: "#1B5E20"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M298.5 597.5l-27.6-.2-1.3-12.6 32.2.3z", fill: "#005F2A" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M260 499.2h108.1v46.7H260z", fill: "#1B5E20" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M326.2 599c.3 1.8.5 3.5.8 5.4v-.8h24v-6c0-15-8.2-16.6-13.6-16.6-5.3-.1-13.6 3.2-11.2 18z",
          fill: "#B71C1C"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M263.2 393h95.9v83.5h-95.9z", fill: "#6CBE70" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M303.6 521.5c-2 15.7 14.5 69.7 26.6 67.4 6-1.1 9.6 0 13.6 0 15 0 36.6-46.3 36.6-65.7 0-19.4-24.6-20.4-39.6-20.4-15.1 0-34.8-.6-37.2 18.7z",
          fill: "#1B5E20"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M192.8 379.1c-5.1 11.4 3.5 24.9-4 25.4-16.3 1.1-21-31.7-12.7-38.9 8.4-7.2 10.4-24.9 15.2-10.1 1.7 5.1 6 13.5 1.5 23.6z",
          fill: "#FFCC80"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M246.5 475.8h131.3v23.4H246.5z", fill: "#402E25" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M300.8 475H328v21.1h-27.2z",
          fill: "none",
          stroke: "#FFEA00",
          strokeWidth: "9"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M291 528.6l-71.7-.8-1.5-57.5 28.7-95.4 36.2-4.1-.6 112.5zM341.9 530.3l64-7.1-4.3-58.1-35.1-93.9-32.8-.9 11.6 113.5z",
          fill: "#2E7D32"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M228.1 446.7c-13.7 11-43.2 22.8-44.6 22.7-9.4-.7-17.3-18-15.9-36.1 1.4-18.1 5.4-34.8 14.8-35.3 14.6-.8 16.6 13.1 16 28.3 2.4-2.8 5-5.4 7.6-7.5 15-12 36.7-21.8 42.8-14.2 6 7.9-5.7 30.1-20.7 42.1z",
          fill: "#2E7D32"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M200.004 413.574l-30.358-3.837 2.094-16.568 30.36 3.836z",
          fill: "#2E7D32"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M254 492.4l28.7-15.1.7-96.6-43.7 33.9 24.9 29.5z",
          fill: "#43A047"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M445.7 506.7c-4.5 5.3 10.6 12.8 4.5 17.4 5.7-4.3-13.6.5-13.6-13.6 0-6 2.4-10.9 5.3-10.9 3-.1 7.8 2.5 3.8 7.1z",
          fill: "#FFCC80"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M429.5 554.9c-8.8-31.6 37.9-79.7 69.8-19.5",
          fill: "none",
          stroke: "#3E2723",
          strokeWidth: "5"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M469 513.9c0 6-8.2 20-15.7 17-24.9-9.8-1.1-14.4-1.5-15.9-1-3.5-8.3-6.2-8.3-9.1 0-10.2 2.4-18.1 10.5-18.1 8.1.1 15 15.9 15 26.1z",
          fill: "#FFCC80"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M454.9 494.7c-15.7 7-22.4-11-27.7-28.4-2.2-7.1-3.6-14.1-3.9-20-10.2-.1-22-2.4-30.7-6.7-17.2-8.5-35.3-24-31-32.7 4.3-8.8 29.5-7.6 46.7.9 14.4 7.1 30.8 18.1 35.8 25.9 3.6 5.7 9 13.8 11.7 22.7 5.4 17.4 7.7 34.5-.9 38.3z",
          fill: "#2E7D32"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M432.836 489.665l29.685-7.43 4.056 16.2-29.686 7.43z",
          fill: "#2E7D32"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M375.3 489.7l-30.1-11.9-11.1-96 47.2 29.1-21.6 31.9z",
          fill: "#43A047"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M369.5 332.4c0 13.7-.8 50.3 12.1 57.3 14.3 7.8-22.6 25.7-34.7 14.8-6.3-5.7-22.8-3.4-35.5-10.1-1.4-.7-31.5 11.1-32.5 12.5-10.6 15.6-55.1-3.9-41.5-17.9 11.7-12.1 8.3-39.6 8.3-56.6 0-31.2 26.2-59.7 60.4-59.7s63.4 28.5 63.4 59.7z",
          fill: "#FF6F00"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M364.2 343c-10.1 20.1-25.5 41.5-55.1 41.5s-39.9-18.6-52.1-37.4c-12.1-18.7-.6-60.7 45.3-67.5 43.8-6.6 71.7 43.9 61.9 63.4z",
          fill: "#FFCC80"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M320.4 336.5c0 4.3-5.4 7.1-10.9 7.1s-9.9-2.3-9.9-6.6 3.7-4.8 9.2-4.8c5.5.1 11.6 0 11.6 4.3z",
          fill: "#FF8A65"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M318.9 363.3h-17.3l-15.1-10.6H331zM295.9 325.1c-.5 1.6-5.6 1.2-11.7 1.2s-13.3 1.8-13.7-1.5c-.9-6.6 7.8-14.5 13.9-14.5 6.1 0 13.1 9.7 11.5 14.8z",
          fill: "#FFF"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M256.3 334.6c0 6.3.3 11.3-5.3 11.3s-12.3-5.7-15.1-11.3c-3.8-7.5.4-16.6 6-16.6 5.7 0 14.4 10.4 14.4 16.6zM361.6 332c0 6.3-.3 11.3 5.3 11.3s12.3-5.7 15.1-11.3c3.8-7.5-.4-16.6-6-16.6s-14.4 10.3-14.4 16.6z",
          fill: "#FFCC80"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M283.9 292.3c-9.3 5.4-12.9 12.3-18.9 17.4l-3.5 52.7-15.1 7.6s-11.6-96.2 19.6-101.9c18.5-3.4 42.3-7.6 44.8 7.6 1.1 6.4-10.6 7.3-26.9 16.6zM319.7 391.2l-15.9-.7 2.7-17.8h9.8z",
          fill: "#FF6F00"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M369.5 372.7l-15.8-9.4-.7-52.8c-5.5-4.7-12.3-10.9-19.6-15.9-13.5-9-29.6-17.9-26.4-23.4 3.2-5.5 26.4-9 41.5-3 31.2 12.5 21 104.5 21 104.5zM294.8 303.4l-38.9 7.8 8.7-13.9 31.7-2.7z",
          fill: "#FF6F00"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M321.9 302.7l30.2 3.2v-9.4l-31.7-2.7z", fill: "#FF6F00" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M291.4 318.3c0 3.9-3.1 7.3-7.2 7.3s-7.7-3.4-7.7-7.3 3.3-7 7.4-7 7.5 3.1 7.5 7z",
          fill: "#50B848"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M320.5 324.6c.5 1.6 5.6 1.2 11.7 1.2s13.3 1.8 13.7-1.5c.9-6.6-7.8-14.5-13.9-14.5-6.1 0-13.2 9.7-11.5 14.8z",
          fill: "#FFF"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M325 317.8c0 3.9 3.1 7.3 7.2 7.3s7.7-3.4 7.7-7.3-3.3-7-7.4-7c-4.2-.1-7.5 3.1-7.5 7z",
          fill: "#50B848"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { cx: "280.3", cy: "338.1", fill: "#FFB59E", rx: "12.2", ry: "6.8" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { cx: "338.4", cy: "338.6", fill: "#FFB59E", rx: "12.5", ry: "7.3" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M349.9 268.2l-91.4 3-9.8-79.3 104.9-3z", fill: "#1B5E20" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M367.4 171.2c-48.1 11.8-38.3 74.6-38.1 69.9",
          fill: "none",
          stroke: "#204F23",
          strokeWidth: "6"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M349.9 262.9l-91.4 3L254 238l98.1-2.3z", fill: "#3E2723" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M320.4 265.9l-29.4 2.3-3-32.5 30.9-1.5z",
          fill: "none",
          stroke: "#FFEA00",
          strokeWidth: "9"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M398.2 282.5c-2.3 17.4-26.4 18.9-53.6 12.1-7.3-1.8-17.9-4.2-28.5-7-8.2-2.1-16.8-1.5-24.6 1.7-10.7 4.4-21.6 8.6-29.9 12.1C213.2 321.8 214 291 214 281c0-10 13.5-24.9 34.7-24.9 12 0 102.6-3 113.2-3 21.3 0 38.6 11.9 36.3 29.4z",
          fill: "#1B5E20"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { id: "leprechaun-clover" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M364.7 172.1c.8-.2 4.7-.1 4.4-.7-2.1-4.1-14-16.5-20.3-17.7-7.4-1.5-13.4 3.5-14.3 8.1-.9 4.6 1.4 11.6 8.8 13.1s13.3-1.2 21.4-2.8z",
            fill: "#006B2A"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M366 168.8c1.1.9 3.6 3.9 3.3 2.4-.9-4.5 4-21.2 1.1-26.9-3.4-6.7-11.1-8.2-15.3-6-4.2 2.2-9.5 10.7-4.2 16 7.5 7.4 9 9.3 15.1 14.5z",
            fill: "#017C2A"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M370 167.4c-.3.8-2.3 4.1-1.6 4.2 4.6.3 21.3-3.7 25.6-8.4 5-5.6 3.8-13.3.3-16.5-3.5-3.2-10.7-4.7-15.8.9-5.1 5.5-5.7 11.9-8.5 19.8z",
            fill: "#006B2A"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M372.2 170.1c-1.4.5-5.2 1.1-3.8 1.6 4.4 1.5 16.2 14.3 22.6 14.6 7.5.4 12.7-5.4 13-10.1.3-4.7-4.4-13.7-11.7-11.7-10.1 2.7-12.5 3-20.1 5.6z",
            fill: "#017C2A"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M371.1 174.6c-.5-.6-2.4-4.1-2.8-3.5-2.6 3.8-7.5 20.3-5.6 26.4 2.3 7.2 9.6 9.9 14.1 8.5 4.5-1.4 9.4-6.9 7.2-14.1-2.3-7.2-7.6-11-12.9-17.3z",
            fill: "#006B2A"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M367.6 175.1c.3-1.4 1.6-5 .5-4.1-3.5 3-20.5 6.9-24 12.2-4.1 6.3-1.7 13.7 2.2 16.3 3.9 2.6 14 3.1 16-4.2 2.8-10.1 3.7-12.4 5.3-20.2z",
            fill: "#017C2A"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M211.4 651.1c1.6 13.7 6.3 25 34.6 21.9 23.9-2.6 48.3-3.6 48.5-4 5.6-15.3-1.1-32.6-1.5-32.6-16.1.8-54.7 14.4-75-5.8-8.9-8.7-7.5 12.7-6.6 20.5z",
          fill: "#3E2723"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M267 642.1l27.6 2.1 4.4-21.8-33.9-.9z", fill: "#3E2723" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M266.5 641.1l29.4-1.4 2.1-7.9-31.9 1z", fill: "#1E1511" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M267.8 641l9.1 1.1 1.9-10.6-13.3-1.6z",
          fill: "none",
          stroke: "#FFD400",
          strokeWidth: "3"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M518.2 560.3c27.2 36.2-14.5 63.5-34.7 66.4-57.4 8.3-57.4-29.4-51.3-57.4 3.3-15.5 24.1-26.4 44.5-26.4s29.3 1.2 41.5 17.4z",
          fill: "#3E2723"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
          cx: "466.5",
          cy: "551.2",
          fill: "#3E2723",
          rx: "15.4",
          ry: "42.2",
          transform: "rotate(-104.288 466.498 551.218)"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "446.1", cy: "551.6", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "481.2", cy: "535.4", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "450.3", cy: "539.2", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "440", cy: "550.9", fill: "#FFCA19", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "472.1", cy: "547.5", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "466.9", cy: "539.2", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "458", cy: "538.9", fill: "#FFCA19", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "485.7", cy: "537.7", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "481.7", cy: "551.7", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "453.7", cy: "546.7", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "459.3", cy: "550.5", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "472.1", cy: "536.1", fill: "#FFCA19", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "453", cy: "556.9", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "491", cy: "545.9", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "470", cy: "554.9", fill: "#FFEA00", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "481", cy: "543.9", fill: "#FFCA19", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "462", cy: "555.9", fill: "#FFCA19", r: "7.2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M469.4 566.1c-23.1 5.9-43.7 3.8-45.8-4.7-.8-3.2 1.1-6.8 5-10.4 5.7 3.9 14.1 6.5 24.2 6.5 19.8 0 45.1-8.2 43-21.6-.2-1.2-.6-2.3-1.3-3.4 7.2 1 12 3.6 13 7.5 2.1 8.5-15 20.2-38.1 26.1z",
          fill: "#5D4037",
          stroke: "#5D4037"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { id: "leprechaun-smoke", fill: "none", stroke: "#E1E0EA", strokeWidth: "4" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { cx: "125", cy: "365.7", rx: "11", ry: "4.5" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { cx: "125", cy: "365.7", rx: "11", ry: "4.5" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { cx: "125", cy: "365.7", rx: "11", ry: "4.5" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", { cx: "125", cy: "365.7", rx: "11", ry: "4.5" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M211.4 371.2l-1 3.6-.1.2-5.9-.3-15-.7-.6.4-33.1 24.4-20-10.2-20.3-.4-8-31.2h35.8l-.8 3.8-2.8 12.7-.1.5 14.4 8.9 18.9-8.7 14.3-6.6z",
          fill: "#3E2723"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M189.4 375.7c-4.6 3.9-3.9 19.2-5.8 17-1.9-2.2-5.7-21-1.1-25s14.5-10.4 16.4-8.2c1.9 2.3-4.9 12.3-9.5 16.2z",
          fill: "#FFCC80"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M327.9 613.3c.3 3.4.7 6.7 1 9.8.4 3.6 1 7 1.7 9.8 1.4 5.5 3.4 9.1 6.9 9.1 4.9 0 8.2-3 10.3-9.1.9-2.7 1.6-5.9 2.1-9.8.4-2.9.7-6.2.9-9.8h-22.9z",
          fill: "#B71C1C"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M326.9 603.5v.8c.4 3 .7 6 1 9h22.8c.2-3 .3-6.3.3-9.8h-24.1z",
          fill: "#FF0"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M329 623.1c.4 3.6 1 7 1.7 9.8h17.1c.9-2.7 1.6-5.9 2.1-9.8H329z",
          fill: "#FFD400"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M324.7 596.2l27.6-.2 1.3-12.6-32.2.2z", fill: "#005F2A" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M411.8 649.8c-1.6 13.7-6.3 25-34.6 21.9-23.9-2.6-48.3-3.6-48.5-4-5.6-15.3 1.1-32.6 1.5-32.6 16.1.8 54.7 14.4 75-5.8 8.9-8.7 7.5 12.7 6.6 20.5z",
          fill: "#3E2723"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M356.2 640.7l-27.6 2.2-4.4-21.8 33.9-.9z", fill: "#3E2723" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M356.7 639.8l-29.4-1.4-2.1-7.9 31.9 1z", fill: "#1E1511" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M355.4 639.7l-9.1 1.1-1.9-10.6 13.3-1.7z",
          fill: "none",
          stroke: "#FFD400",
          strokeWidth: "3"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "311.1", cy: "405.6", fill: "#B71C1C", r: "13.6" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M314.5 400.9l42.6-18.7c4.6-2 10.3.5 10.2 4.6l-.2 37.6c0 4-5.7 6.5-10.3 4.5L314.4 410c-4.5-2-4.5-7.1.1-9.1z",
          fill: "#B71C1C"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M309.8 400.9l-42.6-18.7c-4.6-2-10.3.5-10.2 4.6l.2 37.6c0 4 5.7 6.5 10.3 4.5l42.4-18.9c4.5-2 4.5-7.1-.1-9.1z",
          fill: "#B71C1C"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "312.1", cy: "436.7", fill: "#FBC02D", r: "7.1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "312.1", cy: "456.9", fill: "#FBC02D", r: "7.1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M602 420.9c0 165.7-134.3 300-300 300S2 586.6 2 420.9s134.3-300 300-300 300 134.3 300 300",
          fill: "none"
        })
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (_class);

/***/ })

});


// WEBPACK FOOTER //
// 22.9566856b750e5ce7af03.js